import React from "react";
import {IntlProvider, FormattedDate, FormattedTime} from "react-intl";
import { ICodeValidationResponse } from "../../models/ICodeValidationResponse";

const CodeSuccess = (props: { item: ICodeValidationResponse }) => {

  return (
    <IntlProvider locale="en-GB" timeZone="Europe/London">
    <div className="container-fluid">
      <h1>Thank you!</h1>
      <div className="row row-qr justify-content-md-center success">
        <div className="col" style={{ color: "#ffda00" }}>
          <span style={{ fontSize: "1.3rem" }}>
            Your parking has been validated.
          </span>
          <table className="exemption-detail">
            <tbody>
            <tr><td>Vehicle</td><td>&nbsp;-&nbsp;</td><td><b style={{ textTransform: "uppercase" }}>{props.item.vrm}</b></td></tr>
            <tr><td>Valid Until</td><td>&nbsp;-&nbsp;</td><td><b>
              <FormattedDate value={props.item.validTo} year="numeric" month="2-digit" day="2-digit"/>
              &nbsp;
              <FormattedTime value={props.item.validTo} />
            </b></td></tr>
            <tr><td>Location</td><td>&nbsp;-&nbsp;</td><td><b>{props.item.site}</b></td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </IntlProvider>
  );
};

export default CodeSuccess;
